const { Box, Typography } = require("@mui/material");

const ListComponent = ({ title, data, textStyle }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
      <Typography
        sx={{ width: "100%", fontSize: 16, color: "grey", ...textStyle }}
      >
        {title}
      </Typography>
      <Typography
        sx={{ width: "100%", fontSize: 16, color: "black", ...textStyle }}
      >
        {data}
      </Typography>
    </Box>
  );
};

export default ListComponent;
